import React from "react";
import classes from "./InputText.module.css";
export default function InputText(props) {
  return (
    <input
      onChange={props.onChange}
      placeholder={props.placeholder}
      type={props.type}
      className={classes.inputText}
      style={props.style}
      name={props.name}
      value={props.value}
      required={props.required}
    />
  );
}
